import { SET_WEBSITE } from "../actionTypes";

const initialState = "";

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_WEBSITE: {
      return action.payload;
    }
    default:
      return state;
  }
};
